var map = {
	"./app-icons/abstract/attach-solid.svg": 48468,
	"./app-icons/abstract/attach.svg": 73444,
	"./app-icons/abstract/design-solid.svg": 90699,
	"./app-icons/abstract/design.svg": 64155,
	"./app-icons/abstract/emoji-solid.svg": 18871,
	"./app-icons/abstract/emoji.svg": 89041,
	"./app-icons/abstract/extensions-solid.svg": 72860,
	"./app-icons/abstract/extensions.svg": 30930,
	"./app-icons/abstract/look-and-feel-solid.svg": 77098,
	"./app-icons/abstract/look-and-feel.svg": 61358,
	"./app-icons/abstract/pin-solid.svg": 79133,
	"./app-icons/abstract/pin.svg": 16133,
	"./app-icons/abstract/send-solid.svg": 79297,
	"./app-icons/abstract/send.svg": 74873,
	"./app-icons/abstract/social-likes-solid.svg": 57934,
	"./app-icons/abstract/social-likes.svg": 61856,
	"./app-icons/abstract/vacation-solid.svg": 46146,
	"./app-icons/abstract/vacation.svg": 64119,
	"./app-icons/business/agreement-solid.svg": 90862,
	"./app-icons/business/agreement.svg": 62928,
	"./app-icons/business/coins-solid.svg": 77770,
	"./app-icons/business/coins.svg": 93796,
	"./app-icons/business/dollar-solid.svg": 52314,
	"./app-icons/business/dollar.svg": 62572,
	"./app-icons/business/donut-solid.svg": 64820,
	"./app-icons/business/donut.svg": 55765,
	"./app-icons/business/stats-solid.svg": 47822,
	"./app-icons/business/stats.svg": 81132,
	"./app-icons/comms/ads1-solid.svg": 71406,
	"./app-icons/comms/ads1.svg": 35483,
	"./app-icons/comms/ads2-solid.svg": 98990,
	"./app-icons/comms/ads2.svg": 71552,
	"./app-icons/comms/calls-solid.svg": 38646,
	"./app-icons/comms/calls.svg": 66997,
	"./app-icons/comms/email-solid.svg": 21424,
	"./app-icons/comms/email.svg": 22150,
	"./app-icons/crisis/bug-solid.svg": 77941,
	"./app-icons/crisis/bug.svg": 67696,
	"./app-icons/crisis/fire-solid.svg": 3329,
	"./app-icons/crisis/fire.svg": 69547,
	"./app-icons/crisis/flood-solid.svg": 47220,
	"./app-icons/crisis/flood.svg": 94946,
	"./app-icons/crisis/hazard-solid.svg": 54452,
	"./app-icons/crisis/hazard.svg": 33172,
	"./app-icons/crisis/medical-solid.svg": 37962,
	"./app-icons/crisis/medical.svg": 3215,
	"./app-icons/crisis/radioactive-solid.svg": 16083,
	"./app-icons/crisis/radioactive.svg": 21435,
	"./app-icons/crisis/unknown-solid.svg": 15138,
	"./app-icons/crisis/unknown.svg": 16947,
	"./app-icons/crisis/virus-solid.svg": 38957,
	"./app-icons/crisis/virus.svg": 9138,
	"./app-icons/crisis/weather-solid.svg": 24633,
	"./app-icons/crisis/weather.svg": 30246,
	"./app-icons/digital/cloud-solid.svg": 80762,
	"./app-icons/digital/cloud.svg": 32121,
	"./app-icons/digital/download-solid.svg": 19820,
	"./app-icons/digital/download.svg": 94712,
	"./app-icons/digital/image-solid.svg": 36894,
	"./app-icons/digital/image.svg": 95973,
	"./app-icons/digital/link-solid.svg": 18380,
	"./app-icons/digital/link.svg": 89457,
	"./app-icons/digital/share-ios-style-solid.svg": 29773,
	"./app-icons/digital/share-ios-style.svg": 49007,
	"./app-icons/digital/share-social-style-solid.svg": 77801,
	"./app-icons/digital/share-social-style.svg": 72569,
	"./app-icons/digital/share-solid.svg": 52983,
	"./app-icons/digital/share.svg": 37170,
	"./app-icons/digital/social-mentions-solid.svg": 91457,
	"./app-icons/digital/social-mentions.svg": 30449,
	"./app-icons/digital/thread-solid.svg": 12714,
	"./app-icons/digital/thread.svg": 41105,
	"./app-icons/digital/upload-solid.svg": 58515,
	"./app-icons/digital/upload.svg": 28651,
	"./app-icons/digital/www-solid.svg": 91528,
	"./app-icons/digital/www.svg": 35342,
	"./app-icons/general/application-solid.svg": 78316,
	"./app-icons/general/application.svg": 71059,
	"./app-icons/general/applications-solid.svg": 46882,
	"./app-icons/general/applications.svg": 60497,
	"./app-icons/general/edit-wysiwyg-solid.svg": 91125,
	"./app-icons/general/edit-wysiwyg.svg": 55130,
	"./app-icons/general/menus-solid.svg": 12388,
	"./app-icons/general/menus.svg": 48039,
	"./app-icons/general/panels-solid.svg": 75025,
	"./app-icons/general/panels.svg": 39626,
	"./app-icons/general/wiki-descriptor-solid.svg": 22076,
	"./app-icons/general/wiki-descriptor.svg": 8832,
	"./app-icons/general/wiki-rights-solid.svg": 76610,
	"./app-icons/general/wiki-rights.svg": 33681,
	"./app-icons/general/wiki-solid.svg": 72291,
	"./app-icons/general/wiki-templates-solid.svg": 31439,
	"./app-icons/general/wiki-templates.svg": 15469,
	"./app-icons/general/wiki.svg": 52861,
	"./app-icons/people/members-add-solid.svg": 8404,
	"./app-icons/people/members-add.svg": 29157,
	"./app-icons/people/users-authentication-solid.svg": 57653,
	"./app-icons/people/users-authentication.svg": 30948,
	"./app-icons/people/users-default-solid.svg": 12792,
	"./app-icons/people/users-default.svg": 20801,
	"./app-icons/people/users-groups-solid.svg": 47002,
	"./app-icons/people/users-groups.svg": 8843,
	"./app-icons/people/users-profile-solid.svg": 5179,
	"./app-icons/people/users-profile.svg": 76424,
	"./app-icons/people/users-registration-solid.svg": 5247,
	"./app-icons/people/users-registration.svg": 33812,
	"./app-icons/people/users-rights-solid.svg": 70723,
	"./app-icons/people/users-rights.svg": 62476,
	"./app-icons/security/open-solid.svg": 51380,
	"./app-icons/security/open.svg": 40708,
	"./app-icons/security/other-captcha-solid.svg": 56093,
	"./app-icons/security/other-captcha.svg": 8471,
	"./app-icons/security/private-solid.svg": 2440,
	"./app-icons/security/private.svg": 18865,
	"./app-icons/security/users-authentication-solid.svg": 12654,
	"./app-icons/security/users-authentication.svg": 54629,
	"./compact/add-field-compact-focus.svg": 15007,
	"./compact/add-field-compact.svg": 35314,
	"./compact/add-record-compact-focus.svg": 44917,
	"./compact/add-record-compact.svg": 88975,
	"./compact/application-compact-focus.svg": 84519,
	"./compact/application-compact.svg": 94290,
	"./compact/approval-compact-focus.svg": 19723,
	"./compact/approval-compact.svg": 16892,
	"./compact/apps-compact-focus.svg": 57380,
	"./compact/apps-compact.svg": 27604,
	"./compact/attach-compact-focus.svg": 12818,
	"./compact/attach-compact.svg": 2641,
	"./compact/book-compact-focus.svg": 84979,
	"./compact/book-compact.svg": 35643,
	"./compact/burger-menu-compact-focus.svg": 54107,
	"./compact/burger-menu-compact.svg": 54035,
	"./compact/calendar-compact-focus.svg": 82024,
	"./compact/calendar-compact.svg": 43061,
	"./compact/camera-switch-compact-focus.svg": 36729,
	"./compact/camera-switch-compact.svg": 96673,
	"./compact/card-compact-focus.svg": 82036,
	"./compact/card-compact.svg": 55911,
	"./compact/chat-compact-focus.svg": 56890,
	"./compact/chat-compact.svg": 2495,
	"./compact/close-compact-focus.svg": 20462,
	"./compact/close-compact.svg": 19165,
	"./compact/comment-compact-focus.svg": 3399,
	"./compact/comment-compact.svg": 80054,
	"./compact/copy-compact-focus.svg": 19719,
	"./compact/copy-compact.svg": 34718,
	"./compact/delete-compact-focus.svg": 63741,
	"./compact/delete-compact.svg": 53620,
	"./compact/download-compact-focus.svg": 40002,
	"./compact/download-compact.svg": 51582,
	"./compact/edit-compact-focus.svg": 13559,
	"./compact/edit-compact.svg": 18882,
	"./compact/email-compact-focus.svg": 90105,
	"./compact/email-compact.svg": 35208,
	"./compact/emoji-compact-focus.svg": 7001,
	"./compact/emoji-compact.svg": 77223,
	"./compact/export-compact-focus.svg": 48476,
	"./compact/export-compact.svg": 48527,
	"./compact/extensions-compact-focus.svg": 58054,
	"./compact/extensions-compact.svg": 59766,
	"./compact/eye-compact-focus.svg": 14742,
	"./compact/eye-compact.svg": 57461,
	"./compact/file-compact-focus.svg": 70966,
	"./compact/file-compact.svg": 61930,
	"./compact/files-add-compact-focus.svg": 58588,
	"./compact/files-add-compact.svg": 23998,
	"./compact/files-compact-focus.svg": 56064,
	"./compact/files-compact.svg": 13724,
	"./compact/filter-compact-focus.svg": 70273,
	"./compact/filter-compact.svg": 12330,
	"./compact/filtered-compact-focus.svg": 43605,
	"./compact/filtered-compact.svg": 7527,
	"./compact/folder-closed-add-compact-focus.svg": 92754,
	"./compact/folder-closed-add-compact.svg": 21748,
	"./compact/folder-closed-compact-focus.svg": 81918,
	"./compact/folder-closed-compact.svg": 85973,
	"./compact/folder-closed-move-up-compact-focus.svg": 13232,
	"./compact/folder-closed-move-up-compact.svg": 37905,
	"./compact/folder-empty-compact-focus.svg": 92817,
	"./compact/folder-empty-compact.svg": 16954,
	"./compact/folder-move-compact-focus.svg": 82634,
	"./compact/folder-move-compact.svg": 91747,
	"./compact/folder-open-compact-focus.svg": 80776,
	"./compact/folder-open-compact.svg": 82791,
	"./compact/folder-up-compact-focus.svg": 26042,
	"./compact/folder-up-compact.svg": 20157,
	"./compact/form-compact-focus.svg": 67048,
	"./compact/form-compact.svg": 79082,
	"./compact/gantt-compact-focus.svg": 61599,
	"./compact/gantt-compact.svg": 7002,
	"./compact/grid-compact-focus.svg": 42446,
	"./compact/grid-compact.svg": 41059,
	"./compact/group-compact-focus.svg": 70470,
	"./compact/group-compact.svg": 51505,
	"./compact/history-compact-focus.svg": 40431,
	"./compact/history-compact.svg": 24841,
	"./compact/home-compact-focus.svg": 18453,
	"./compact/home-compact.svg": 18344,
	"./compact/horizontal-ellipsis-compact-focus.svg": 41231,
	"./compact/horizontal-ellipsis-compact.svg": 47268,
	"./compact/image-compact-focus.svg": 50510,
	"./compact/image-compact.svg": 22906,
	"./compact/info-compact-focus.svg": 71559,
	"./compact/info-compact.svg": 40475,
	"./compact/kanban-compact-focus.svg": 12574,
	"./compact/kanban-compact.svg": 190,
	"./compact/link-add-compact-focus.svg": 81793,
	"./compact/link-add-compact.svg": 49978,
	"./compact/link-compact-focus.svg": 12495,
	"./compact/link-compact.svg": 86381,
	"./compact/list-compact-focus.svg": 48724,
	"./compact/list-compact.svg": 86448,
	"./compact/lock-compact-focus.svg": 2359,
	"./compact/lock-compact.svg": 10090,
	"./compact/log-out-compact-focus.svg": 26021,
	"./compact/log-out-compact.svg": 41778,
	"./compact/look-and-feel-compact-focus.svg": 30968,
	"./compact/look-and-feel-compact.svg": 34304,
	"./compact/maximise-compact-focus.svg": 87447,
	"./compact/maximise-compact.svg": 65126,
	"./compact/meeting-participant-add-compact-focus.svg": 25829,
	"./compact/meeting-participant-add-compact.svg": 22763,
	"./compact/members-add-compact-focus.svg": 40132,
	"./compact/members-add-compact.svg": 65373,
	"./compact/members-compact-focus.svg": 27348,
	"./compact/members-compact.svg": 94253,
	"./compact/microphone-compact-focus.svg": 74933,
	"./compact/microphone-compact.svg": 8318,
	"./compact/minimise-compact-focus.svg": 62585,
	"./compact/minimise-compact.svg": 7021,
	"./compact/news-compact-focus.svg": 36791,
	"./compact/news-compact.svg": 3725,
	"./compact/note-compact-focus.svg": 68422,
	"./compact/note-compact.svg": 69243,
	"./compact/notifications-compact-focus.svg": 47844,
	"./compact/notifications-compact.svg": 93051,
	"./compact/open-compact-focus.svg": 7020,
	"./compact/open-compact.svg": 34466,
	"./compact/organiser-compact-focus.svg": 85875,
	"./compact/organiser-compact.svg": 35401,
	"./compact/other-captcha-compact-focus.svg": 19459,
	"./compact/other-captcha-compact.svg": 86256,
	"./compact/phone-compact-focus.svg": 82466,
	"./compact/phone-compact.svg": 95619,
	"./compact/pin-compact-focus.svg": 84733,
	"./compact/pin-compact.svg": 25347,
	"./compact/play-compact-focus.svg": 81978,
	"./compact/play-compact.svg": 71083,
	"./compact/plus-compact-focus.svg": 26258,
	"./compact/plus-compact.svg": 36370,
	"./compact/privacy-compact-focus.svg": 67970,
	"./compact/privacy-compact.svg": 21140,
	"./compact/profile-compact-focus.svg": 57233,
	"./compact/profile-compact.svg": 63517,
	"./compact/reaction-add-compact-focus.svg": 89930,
	"./compact/reaction-add-compact.svg": 82542,
	"./compact/refresh-compact-focus.svg": 56708,
	"./compact/refresh-compact.svg": 17604,
	"./compact/reset-compact.svg": 21245,
	"./compact/search-compact-focus.svg": 74252,
	"./compact/search-compact.svg": 78252,
	"./compact/send-compact-focus.svg": 7653,
	"./compact/send-compact.svg": 66497,
	"./compact/settings-compact-focus.svg": 13030,
	"./compact/settings-compact.svg": 16068,
	"./compact/share-compact-focus.svg": 74936,
	"./compact/share-compact.svg": 46411,
	"./compact/sliders-compact-focus.svg": 19177,
	"./compact/sliders-compact.svg": 12588,
	"./compact/social-likes-compact-focus.svg": 62796,
	"./compact/social-likes-compact.svg": 85450,
	"./compact/start-thread-compact-focus.svg": 19557,
	"./compact/start-thread-compact.svg": 52660,
	"./compact/stats-compact-focus.svg": 55640,
	"./compact/stats-compact.svg": 86105,
	"./compact/table-compact-focus.svg": 64727,
	"./compact/table-compact.svg": 86106,
	"./compact/tag-compact-focus.svg": 29362,
	"./compact/tag-compact.svg": 78515,
	"./compact/tasks-compact-focus.svg": 56699,
	"./compact/tasks-compact.svg": 69664,
	"./compact/templates-compact-focus.svg": 89410,
	"./compact/templates-compact.svg": 21533,
	"./compact/text-file-compact-focus.svg": 97999,
	"./compact/text-file-compact.svg": 56963,
	"./compact/tile-view-compact-focus.svg": 90738,
	"./compact/tile-view-compact.svg": 53574,
	"./compact/trash-3-compact.svg": 57347,
	"./compact/trash-compact-focus.svg": 73223,
	"./compact/trash-compact.svg": 31582,
	"./compact/unknown-warning-compact-focus.svg": 38008,
	"./compact/unknown-warning-compact.svg": 87602,
	"./compact/users-authentication-compact-focus.svg": 93212,
	"./compact/users-authentication-compact.svg": 87786,
	"./compact/video-compact-focus.svg": 50355,
	"./compact/video-compact.svg": 21965,
	"./compact/visibility-hidden.svg": 93903,
	"./compact/visibility-invisible.svg": 83852,
	"./compact/visibility-visible.svg": 20253,
	"./compact/workflows-compact-focus.svg": 89017,
	"./compact/workflows-compact.svg": 54560,
	"./compact/workspaces-compact-focus.svg": 79660,
	"./compact/workspaces-compact.svg": 88178,
	"./compact/x-compact-focus.svg": 39586,
	"./compact/x-compact.svg": 77457,
	"./compact/zoom-in-compact-focus.svg": 73244,
	"./compact/zoom-in-compact.svg": 82922,
	"./compact/zoom-out-compact-focus.svg": 28103,
	"./compact/zoom-out-compact.svg": 22995,
	"./compact/zoom-reset-compact-focus.svg": 5259,
	"./compact/zoom-reset-compact.svg": 71688,
	"./emoji-category/activity.svg": 3512,
	"./emoji-category/foods.svg": 27515,
	"./emoji-category/nature.svg": 46546,
	"./emoji-category/objects.svg": 85685,
	"./emoji-category/peoples.svg": 42546,
	"./emoji-category/places.svg": 59570,
	"./emoji-category/symbols.svg": 98246,
	"./flat/add-compact.svg": 63229,
	"./flat/add-field-compact.svg": 396,
	"./flat/add-field-light.svg": 24927,
	"./flat/add-field-solid.svg": 30760,
	"./flat/add-fork-compact.svg": 25492,
	"./flat/add-fork-light.svg": 97749,
	"./flat/add-fork-solid.svg": 74458,
	"./flat/add-light.svg": 59458,
	"./flat/add-record-compact.svg": 19541,
	"./flat/add-record-light.svg": 93201,
	"./flat/add-record-solid.svg": 9247,
	"./flat/add-solid.svg": 50323,
	"./flat/ai-compact.svg": 57326,
	"./flat/ai-light.svg": 75622,
	"./flat/ai-solid.svg": 39607,
	"./flat/application-compact.svg": 12442,
	"./flat/application-index-compact.svg": 15303,
	"./flat/application-index-light.svg": 24885,
	"./flat/application-index-solid.svg": 6475,
	"./flat/application-light.svg": 71804,
	"./flat/application-solid.svg": 44298,
	"./flat/approval-compact.svg": 84396,
	"./flat/approval-light.svg": 46884,
	"./flat/approval-solid.svg": 35530,
	"./flat/apps-compact.svg": 47575,
	"./flat/apps-light.svg": 43000,
	"./flat/apps-solid.svg": 10802,
	"./flat/attach-compact.svg": 72720,
	"./flat/attach-light.svg": 38655,
	"./flat/attach-solid.svg": 49735,
	"./flat/attribute-type/article.svg": 80455,
	"./flat/attribute-type/checkbox.svg": 69512,
	"./flat/attribute-type/content.svg": 34350,
	"./flat/attribute-type/createdBy.svg": 39378,
	"./flat/attribute-type/createdDate.svg": 87742,
	"./flat/attribute-type/date.svg": 25819,
	"./flat/attribute-type/formula.svg": 93036,
	"./flat/attribute-type/image.svg": 83674,
	"./flat/attribute-type/lastUpdated.svg": 9419,
	"./flat/attribute-type/lastUpdatedBy.svg": 14407,
	"./flat/attribute-type/longText.svg": 72139,
	"./flat/attribute-type/number.svg": 89321,
	"./flat/attribute-type/percent.svg": 33799,
	"./flat/attribute-type/ruleset.svg": 2860,
	"./flat/attribute-type/select.svg": 41230,
	"./flat/attribute-type/task.svg": 91192,
	"./flat/attribute-type/text.svg": 79829,
	"./flat/attribute-type/time.svg": 47729,
	"./flat/attribute-type/track.svg": 1519,
	"./flat/attribute-type/url.svg": 96272,
	"./flat/attribute-type/user.svg": 4686,
	"./flat/bold.svg": 49810,
	"./flat/book-compact.svg": 16110,
	"./flat/book-light.svg": 37491,
	"./flat/book-solid.svg": 71249,
	"./flat/bottom-compact.svg": 69515,
	"./flat/bottom-light.svg": 20941,
	"./flat/bottom-solid.svg": 65321,
	"./flat/burger-menu-compact.svg": 54416,
	"./flat/burger-menu-light.svg": 22732,
	"./flat/burger-menu-solid.svg": 35386,
	"./flat/calendar-compact.svg": 50834,
	"./flat/calendar-light.svg": 78400,
	"./flat/calendar-solid.svg": 39191,
	"./flat/camera-switch-compact.svg": 99082,
	"./flat/camera-switch-light.svg": 32381,
	"./flat/camera-switch-solid.svg": 58189,
	"./flat/card-compact.svg": 65944,
	"./flat/card-light.svg": 5916,
	"./flat/card-solid.svg": 27230,
	"./flat/chat-compact.svg": 17814,
	"./flat/chat-light.svg": 91079,
	"./flat/chat-solid.svg": 80346,
	"./flat/chevron-down-compact.svg": 3025,
	"./flat/chevron-down-light.svg": 94806,
	"./flat/chevron-down-solid.svg": 24909,
	"./flat/chevron-first-compact.svg": 10449,
	"./flat/chevron-first-light.svg": 37223,
	"./flat/chevron-first-solid.svg": 94375,
	"./flat/chevron-last-compact.svg": 31397,
	"./flat/chevron-last-light.svg": 54936,
	"./flat/chevron-last-solid.svg": 93305,
	"./flat/chevron-left-compact.svg": 45985,
	"./flat/chevron-left-light.svg": 25843,
	"./flat/chevron-left-solid.svg": 95881,
	"./flat/chevron-right-compact.svg": 11555,
	"./flat/chevron-right-light.svg": 20445,
	"./flat/chevron-right-solid.svg": 89134,
	"./flat/chevron-up-compact.svg": 8586,
	"./flat/chevron-up-light.svg": 37135,
	"./flat/chevron-up-solid.svg": 65701,
	"./flat/class-compact.svg": 55298,
	"./flat/class-light.svg": 37002,
	"./flat/class-solid.svg": 43464,
	"./flat/close-compact.svg": 49201,
	"./flat/close-light.svg": 60119,
	"./flat/close-solid.svg": 31662,
	"./flat/comment-compact.svg": 52,
	"./flat/comment-light.svg": 64444,
	"./flat/comment-solid.svg": 40053,
	"./flat/conditional-compact.svg": 81725,
	"./flat/conditional-light.svg": 12852,
	"./flat/conditional-overrides-compact.svg": 7894,
	"./flat/conditional-overrides-light.svg": 45907,
	"./flat/conditional-overrides-solid.svg": 35166,
	"./flat/conditional-solid.svg": 95746,
	"./flat/copy-compact.svg": 76285,
	"./flat/copy-light.svg": 10326,
	"./flat/copy-solid.svg": 17676,
	"./flat/dash-compact.svg": 74463,
	"./flat/dash-light.svg": 96867,
	"./flat/dash-solid.svg": 82494,
	"./flat/data-sources-compact.svg": 32586,
	"./flat/data-sources-light.svg": 16791,
	"./flat/data-sources-solid.svg": 62861,
	"./flat/delete-compact.svg": 57917,
	"./flat/delete-light.svg": 46402,
	"./flat/delete-solid.svg": 89165,
	"./flat/dismiss-compact.svg": 60264,
	"./flat/dismiss-light.svg": 26718,
	"./flat/dismiss-solid.svg": 97367,
	"./flat/do-not-disturb-compact.svg": 8583,
	"./flat/do-not-disturb-light.svg": 65881,
	"./flat/do-not-disturb-solid.svg": 13659,
	"./flat/down-2-compact.svg": 6184,
	"./flat/down-2-light.svg": 8893,
	"./flat/down-2-solid.svg": 74654,
	"./flat/down-compact.svg": 95861,
	"./flat/down-light.svg": 67097,
	"./flat/down-solid.svg": 44929,
	"./flat/download-compact.svg": 8195,
	"./flat/download-light.svg": 18958,
	"./flat/download-solid.svg": 99706,
	"./flat/draggable-handle-compact.svg": 81315,
	"./flat/draggable-handle-light.svg": 56084,
	"./flat/draggable-handle-solid.svg": 11057,
	"./flat/edit-compact.svg": 5011,
	"./flat/edit-light.svg": 87638,
	"./flat/edit-solid.svg": 4709,
	"./flat/ellipsis-horizontal-compact.svg": 5638,
	"./flat/ellipsis-horizontal-light.svg": 71785,
	"./flat/ellipsis-horizontal-solid.svg": 85237,
	"./flat/ellipsis-vertical-compact.svg": 44144,
	"./flat/ellipsis-vertical-light.svg": 95564,
	"./flat/ellipsis-vertical-solid.svg": 27967,
	"./flat/email-advanced-settings-compact.svg": 27420,
	"./flat/email-advanced-settings-light.svg": 70654,
	"./flat/email-advanced-settings-solid.svg": 89515,
	"./flat/email-compact.svg": 21512,
	"./flat/email-light.svg": 80027,
	"./flat/email-sending-compact.svg": 1322,
	"./flat/email-sending-light.svg": 62778,
	"./flat/email-sending-solid.svg": 60265,
	"./flat/email-sending-status-compact.svg": 15409,
	"./flat/email-sending-status-light.svg": 82506,
	"./flat/email-sending-status-solid.svg": 36884,
	"./flat/email-solid.svg": 48543,
	"./flat/emoji-compact.svg": 97502,
	"./flat/emoji-light.svg": 29527,
	"./flat/emoji-solid.svg": 90316,
	"./flat/export-compact.svg": 12841,
	"./flat/export-light.svg": 81238,
	"./flat/export-solid.svg": 54569,
	"./flat/extensions-compact.svg": 57235,
	"./flat/extensions-light.svg": 75578,
	"./flat/extensions-solid.svg": 66142,
	"./flat/eye-compact.svg": 91506,
	"./flat/eye-light.svg": 95525,
	"./flat/eye-solid.svg": 79698,
	"./flat/favourite-star-compact.svg": 43697,
	"./flat/favourite-star-light.svg": 18813,
	"./flat/favourite-star-solid.svg": 78187,
	"./flat/file-export-compact.svg": 60841,
	"./flat/file-export-light.svg": 5494,
	"./flat/file-export-solid.svg": 69777,
	"./flat/files-add-compact.svg": 52346,
	"./flat/files-add-light.svg": 26878,
	"./flat/files-add-solid.svg": 503,
	"./flat/files-compact.svg": 58185,
	"./flat/files-light.svg": 41573,
	"./flat/files-solid.svg": 5419,
	"./flat/filter-compact.svg": 69678,
	"./flat/filter-light.svg": 56947,
	"./flat/filter-solid.svg": 47852,
	"./flat/filtered-compact.svg": 66525,
	"./flat/filtered-light.svg": 5416,
	"./flat/filtered-solid.svg": 96755,
	"./flat/first-compact.svg": 30207,
	"./flat/first-light.svg": 19724,
	"./flat/first-solid.svg": 22123,
	"./flat/flash-compact.svg": 88626,
	"./flat/flash-light.svg": 93733,
	"./flat/flash-solid.svg": 1925,
	"./flat/folder-closed-add-compact.svg": 98255,
	"./flat/folder-closed-add-light.svg": 72006,
	"./flat/folder-closed-add-solid.svg": 49117,
	"./flat/folder-closed-compact.svg": 87116,
	"./flat/folder-closed-light.svg": 29166,
	"./flat/folder-closed-move-up-compact.svg": 51990,
	"./flat/folder-closed-move-up-light.svg": 61338,
	"./flat/folder-closed-move-up-solid.svg": 19310,
	"./flat/folder-closed-solid.svg": 91578,
	"./flat/folder-empty-compact.svg": 11100,
	"./flat/folder-empty-light.svg": 19897,
	"./flat/folder-empty-solid.svg": 10866,
	"./flat/folder-move-compact.svg": 85950,
	"./flat/folder-move-light.svg": 15587,
	"./flat/folder-move-solid.svg": 84172,
	"./flat/folder-open-compact.svg": 46749,
	"./flat/folder-open-light.svg": 99406,
	"./flat/folder-open-solid.svg": 23083,
	"./flat/folder-up-compact.svg": 66691,
	"./flat/folder-up-light.svg": 86255,
	"./flat/folder-up-solid.svg": 53757,
	"./flat/font-weight-300.svg": 62857,
	"./flat/font-weight-400.svg": 83477,
	"./flat/font-weight-500.svg": 66016,
	"./flat/font-weight-600.svg": 18821,
	"./flat/font-weight-700.svg": 90829,
	"./flat/form-compact.svg": 13861,
	"./flat/form-light.svg": 66585,
	"./flat/form-solid.svg": 56074,
	"./flat/full-screen-compact.svg": 25489,
	"./flat/full-screen-exit-compact.svg": 5223,
	"./flat/full-screen-exit-light.svg": 30967,
	"./flat/full-screen-exit-solid.svg": 41149,
	"./flat/full-screen-light.svg": 7424,
	"./flat/full-screen-solid.svg": 50890,
	"./flat/gantt-compact.svg": 97230,
	"./flat/gantt-light.svg": 13952,
	"./flat/gantt-solid.svg": 83283,
	"./flat/grid-compact.svg": 88676,
	"./flat/grid-light.svg": 45263,
	"./flat/grid-solid.svg": 89865,
	"./flat/group-2-compact.svg": 28821,
	"./flat/group-2-light.svg": 35959,
	"./flat/group-2-solid.svg": 78685,
	"./flat/group-compact.svg": 87941,
	"./flat/group-light.svg": 8493,
	"./flat/group-solid.svg": 54680,
	"./flat/help-compact.svg": 40289,
	"./flat/help-light.svg": 60869,
	"./flat/help-solid.svg": 15851,
	"./flat/history-compact.svg": 91109,
	"./flat/history-light.svg": 31244,
	"./flat/history-solid.svg": 14606,
	"./flat/home-compact.svg": 96179,
	"./flat/home-light.svg": 46917,
	"./flat/home-solid.svg": 22809,
	"./flat/image-compact.svg": 70118,
	"./flat/image-light.svg": 16118,
	"./flat/image-solid.svg": 31941,
	"./flat/index-compact.svg": 21137,
	"./flat/index-light.svg": 85487,
	"./flat/index-solid.svg": 13722,
	"./flat/info-compact.svg": 93832,
	"./flat/info-light.svg": 479,
	"./flat/info-solid.svg": 21714,
	"./flat/italic.svg": 43174,
	"./flat/join-compact.svg": 79914,
	"./flat/join-light.svg": 18550,
	"./flat/join-solid.svg": 94761,
	"./flat/kanban-compact.svg": 47173,
	"./flat/kanban-light.svg": 74197,
	"./flat/kanban-solid.svg": 36143,
	"./flat/last-compact.svg": 66185,
	"./flat/last-light.svg": 40839,
	"./flat/last-solid.svg": 93946,
	"./flat/layout-film-strip-compact.svg": 63355,
	"./flat/layout-film-strip-light.svg": 34503,
	"./flat/layout-film-strip-solid.svg": 98948,
	"./flat/layout-full-screen-compact.svg": 13481,
	"./flat/layout-full-screen-light.svg": 37968,
	"./flat/layout-full-screen-solid.svg": 36548,
	"./flat/layout-grid-compact.svg": 68383,
	"./flat/layout-grid-light.svg": 35559,
	"./flat/layout-grid-solid.svg": 54786,
	"./flat/layout-righthand-strip-compact.svg": 12448,
	"./flat/layout-righthand-strip-light.svg": 8998,
	"./flat/layout-righthand-strip-solid.svg": 56430,
	"./flat/left-2-compact.svg": 29836,
	"./flat/left-2-light.svg": 51836,
	"./flat/left-2-solid.svg": 54014,
	"./flat/left-compact.svg": 42104,
	"./flat/left-light.svg": 97375,
	"./flat/left-solid.svg": 99730,
	"./flat/link-add-compact.svg": 32057,
	"./flat/link-add-light.svg": 41053,
	"./flat/link-add-solid.svg": 44223,
	"./flat/link-compact.svg": 80758,
	"./flat/link-light.svg": 12520,
	"./flat/link-solid.svg": 19864,
	"./flat/list-compact.svg": 2785,
	"./flat/list-light.svg": 99242,
	"./flat/list-solid.svg": 84990,
	"./flat/lock-compact.svg": 60121,
	"./flat/lock-light.svg": 9418,
	"./flat/lock-solid.svg": 92806,
	"./flat/log-out-compact.svg": 13336,
	"./flat/log-out-light.svg": 95332,
	"./flat/log-out-solid.svg": 24206,
	"./flat/look-and-feel-compact.svg": 47379,
	"./flat/look-and-feel-light.svg": 4609,
	"./flat/look-and-feel-solid.svg": 12136,
	"./flat/maximise-compact.svg": 4329,
	"./flat/maximise-light.svg": 37430,
	"./flat/maximise-solid.svg": 53161,
	"./flat/meeting-participant-add-compact.svg": 71227,
	"./flat/meeting-participant-add-light.svg": 52442,
	"./flat/meeting-participant-add-solid.svg": 5577,
	"./flat/member-out-compact.svg": 18200,
	"./flat/member-out-light.svg": 59620,
	"./flat/member-out-solid.svg": 13491,
	"./flat/members-add-compact.svg": 85720,
	"./flat/members-add-light.svg": 73084,
	"./flat/members-add-solid.svg": 17585,
	"./flat/members-compact.svg": 86337,
	"./flat/members-light.svg": 54797,
	"./flat/members-solid.svg": 50779,
	"./flat/microphone-compact.svg": 215,
	"./flat/microphone-light.svg": 74547,
	"./flat/microphone-mute-compact.svg": 92629,
	"./flat/microphone-mute-light.svg": 76597,
	"./flat/microphone-mute-solid.svg": 13227,
	"./flat/microphone-solid.svg": 62721,
	"./flat/minimise-compact.svg": 47922,
	"./flat/minimise-light.svg": 34241,
	"./flat/minimise-solid.svg": 21496,
	"./flat/news-compact.svg": 81762,
	"./flat/news-light.svg": 22379,
	"./flat/news-solid.svg": 72041,
	"./flat/note-compact.svg": 73554,
	"./flat/note-light.svg": 70009,
	"./flat/note-solid.svg": 15340,
	"./flat/notifications-compact.svg": 82100,
	"./flat/notifications-light.svg": 22154,
	"./flat/notifications-solid.svg": 8898,
	"./flat/objects-compact.svg": 81418,
	"./flat/objects-light.svg": 81412,
	"./flat/objects-solid.svg": 73729,
	"./flat/open-compact.svg": 34403,
	"./flat/open-light.svg": 91145,
	"./flat/open-solid.svg": 52027,
	"./flat/organiser-compact.svg": 80829,
	"./flat/organiser-light.svg": 47140,
	"./flat/organiser-solid.svg": 38312,
	"./flat/other-captcha-compact.svg": 29485,
	"./flat/other-captcha-light.svg": 72130,
	"./flat/other-captcha-solid.svg": 69065,
	"./flat/phone-compact.svg": 98868,
	"./flat/phone-light.svg": 39108,
	"./flat/phone-solid.svg": 88011,
	"./flat/pin-compact.svg": 84551,
	"./flat/pin-light.svg": 50388,
	"./flat/pin-solid.svg": 66357,
	"./flat/play-2-compact.svg": 61292,
	"./flat/play-2-light.svg": 83335,
	"./flat/play-2-solid.svg": 57339,
	"./flat/play-compact.svg": 76845,
	"./flat/play-light.svg": 60266,
	"./flat/play-solid.svg": 43618,
	"./flat/plus-circle-compact.svg": 16281,
	"./flat/plus-circle-light.svg": 68002,
	"./flat/plus-circle-solid.svg": 94776,
	"./flat/plus-compact.svg": 77812,
	"./flat/plus-light.svg": 82461,
	"./flat/plus-solid.svg": 81967,
	"./flat/pop-out-to-modal-compact.svg": 20419,
	"./flat/pop-out-to-modal-light.svg": 94426,
	"./flat/pop-out-to-modal-solid.svg": 55613,
	"./flat/present-compact.svg": 12237,
	"./flat/present-light.svg": 18571,
	"./flat/present-solid.svg": 67677,
	"./flat/print-compact.svg": 3445,
	"./flat/print-light.svg": 32454,
	"./flat/print-solid.svg": 43426,
	"./flat/privacy-compact.svg": 40770,
	"./flat/privacy-light.svg": 90376,
	"./flat/privacy-solid.svg": 29463,
	"./flat/profile-compact.svg": 96254,
	"./flat/profile-light.svg": 13773,
	"./flat/profile-solid.svg": 63156,
	"./flat/reaction-add-compact.svg": 66107,
	"./flat/reaction-add-light.svg": 66658,
	"./flat/reaction-add-solid.svg": 79031,
	"./flat/refresh-compact.svg": 22714,
	"./flat/refresh-light.svg": 70038,
	"./flat/refresh-solid.svg": 7743,
	"./flat/right-2-compact.svg": 75629,
	"./flat/right-2-light.svg": 94334,
	"./flat/right-2-solid.svg": 86387,
	"./flat/right-compact.svg": 43962,
	"./flat/right-light.svg": 78035,
	"./flat/right-solid.svg": 55002,
	"./flat/rules-compact.svg": 92729,
	"./flat/rules-light.svg": 79178,
	"./flat/rules-solid.svg": 60988,
	"./flat/screenshare-compact.svg": 45485,
	"./flat/screenshare-light.svg": 66283,
	"./flat/screenshare-solid.svg": 51908,
	"./flat/search-compact.svg": 54933,
	"./flat/search-light.svg": 41417,
	"./flat/search-solid.svg": 26871,
	"./flat/send-compact.svg": 57006,
	"./flat/send-light.svg": 80057,
	"./flat/send-solid.svg": 37795,
	"./flat/settings-compact.svg": 38731,
	"./flat/settings-light.svg": 2727,
	"./flat/settings-solid.svg": 457,
	"./flat/share-compact.svg": 80899,
	"./flat/share-light.svg": 7353,
	"./flat/share-solid.svg": 49891,
	"./flat/sheild-compact.svg": 84630,
	"./flat/sheild-light.svg": 41716,
	"./flat/sheild-solid.svg": 20046,
	"./flat/sliders-compact.svg": 40154,
	"./flat/sliders-light.svg": 46118,
	"./flat/sliders-solid.svg": 4716,
	"./flat/sliders-vertical-compact.svg": 21274,
	"./flat/sliders-vertical-light.svg": 7816,
	"./flat/sliders-vertical-solid.svg": 30741,
	"./flat/social-likes-compact.svg": 56838,
	"./flat/social-likes-light.svg": 99252,
	"./flat/social-likes-solid.svg": 1667,
	"./flat/sort-ascending-compact.svg": 49436,
	"./flat/sort-ascending-light.svg": 48424,
	"./flat/sort-ascending-solid.svg": 25309,
	"./flat/sort-compact.svg": 11690,
	"./flat/sort-descending-compact.svg": 23324,
	"./flat/sort-descending-light.svg": 33717,
	"./flat/sort-descending-solid.svg": 97506,
	"./flat/sort-light.svg": 15550,
	"./flat/sort-solid.svg": 70646,
	"./flat/start-thread-compact.svg": 86241,
	"./flat/start-thread-light.svg": 75153,
	"./flat/start-thread-solid.svg": 76699,
	"./flat/stats-compact.svg": 75951,
	"./flat/stats-light.svg": 34150,
	"./flat/stats-solid.svg": 13411,
	"./flat/strikethrough.svg": 60188,
	"./flat/table-compact.svg": 8344,
	"./flat/table-light.svg": 44306,
	"./flat/table-solid.svg": 9888,
	"./flat/tag-compact.svg": 75865,
	"./flat/tag-light.svg": 65392,
	"./flat/tag-solid.svg": 61222,
	"./flat/tasks-compact.svg": 78734,
	"./flat/tasks-light.svg": 17332,
	"./flat/tasks-solid.svg": 11579,
	"./flat/templates-compact.svg": 18957,
	"./flat/templates-light.svg": 17991,
	"./flat/templates-solid.svg": 25021,
	"./flat/text-file-compact.svg": 40113,
	"./flat/text-file-light.svg": 30910,
	"./flat/text-file-solid.svg": 77000,
	"./flat/tick-2-compact.svg": 22890,
	"./flat/tick-2-light.svg": 47397,
	"./flat/tick-2-solid.svg": 37221,
	"./flat/tick-circle-compact.svg": 36246,
	"./flat/tick-circle-light.svg": 2328,
	"./flat/tick-circle-solid.svg": 8279,
	"./flat/tick-compact.svg": 28279,
	"./flat/tick-light.svg": 29431,
	"./flat/tick-solid.svg": 44569,
	"./flat/tile-view-compact.svg": 16357,
	"./flat/tile-view-light.svg": 1974,
	"./flat/tile-view-solid.svg": 83719,
	"./flat/timers-compact.svg": 99345,
	"./flat/timers-light.svg": 28448,
	"./flat/timers-solid.svg": 75383,
	"./flat/top-compact.svg": 98530,
	"./flat/top-light.svg": 69304,
	"./flat/top-solid.svg": 93084,
	"./flat/trash-2-compact.svg": 94641,
	"./flat/trash-2-light.svg": 26774,
	"./flat/trash-2-solid.svg": 34349,
	"./flat/trash-3-compact.svg": 38508,
	"./flat/trash-3-light.svg": 69667,
	"./flat/trash-3-solid.svg": 53123,
	"./flat/trash-compact.svg": 2005,
	"./flat/trash-light.svg": 43731,
	"./flat/trash-solid.svg": 98752,
	"./flat/ui-flow-compact.svg": 96162,
	"./flat/ui-flow-light.svg": 9851,
	"./flat/ui-flow-solid.svg": 85432,
	"./flat/underline.svg": 16199,
	"./flat/unknown-warning-compact.svg": 37841,
	"./flat/unknown-warning-light.svg": 37060,
	"./flat/unknown-warning-solid.svg": 44205,
	"./flat/up-2-compact.svg": 65715,
	"./flat/up-2-light.svg": 66102,
	"./flat/up-2-solid.svg": 40807,
	"./flat/up-compact.svg": 2662,
	"./flat/up-light.svg": 41564,
	"./flat/up-solid.svg": 59667,
	"./flat/upload-compact.svg": 21480,
	"./flat/upload-light.svg": 99117,
	"./flat/upload-solid.svg": 82129,
	"./flat/users-authentication-compact.svg": 88349,
	"./flat/users-authentication-light.svg": 6572,
	"./flat/users-authentication-solid.svg": 59846,
	"./flat/users-directory-compact.svg": 52179,
	"./flat/users-directory-light.svg": 43669,
	"./flat/users-directory-solid.svg": 30269,
	"./flat/users-invitation-compact.svg": 97247,
	"./flat/users-invitation-light.svg": 34315,
	"./flat/users-invitation-solid.svg": 47786,
	"./flat/users-rights-compact.svg": 53920,
	"./flat/users-rights-light.svg": 26342,
	"./flat/users-rights-solid.svg": 79393,
	"./flat/video-compact.svg": 2065,
	"./flat/video-light.svg": 93601,
	"./flat/video-muted-compact.svg": 86020,
	"./flat/video-muted-light.svg": 84641,
	"./flat/video-muted-solid.svg": 12840,
	"./flat/video-solid.svg": 55793,
	"./flat/visibility-hidden.svg": 72736,
	"./flat/visibility-invisible.svg": 12522,
	"./flat/visibility-visible.svg": 81654,
	"./flat/warning-circle-compact.svg": 36162,
	"./flat/warning-circle-light.svg": 80384,
	"./flat/warning-circle-solid.svg": 15618,
	"./flat/warning-compact.svg": 17338,
	"./flat/warning-light.svg": 81541,
	"./flat/warning-solid.svg": 71149,
	"./flat/wiki-compact.svg": 1003,
	"./flat/wiki-light.svg": 24182,
	"./flat/wiki-solid.svg": 24531,
	"./flat/workflows-compact.svg": 59231,
	"./flat/workflows-light.svg": 49414,
	"./flat/workflows-solid.svg": 92263,
	"./flat/workspaces-add-compact.svg": 12057,
	"./flat/workspaces-add-light.svg": 41113,
	"./flat/workspaces-add-solid.svg": 79996,
	"./flat/workspaces-compact.svg": 64195,
	"./flat/workspaces-light.svg": 67158,
	"./flat/workspaces-solid.svg": 62565,
	"./flat/x-compact.svg": 99898,
	"./flat/x-light.svg": 9163,
	"./flat/x-solid.svg": 93543,
	"./flat/zap-compact.svg": 27186,
	"./flat/zap-light.svg": 53019,
	"./flat/zap-solid.svg": 69760,
	"./flat/zoom-in-compact.svg": 44993,
	"./flat/zoom-in-light.svg": 15714,
	"./flat/zoom-in-solid.svg": 68157,
	"./flat/zoom-out-compact.svg": 45775,
	"./flat/zoom-out-light.svg": 81411,
	"./flat/zoom-out-solid.svg": 10512,
	"./flat/zoom-reset-compact.svg": 62147,
	"./flat/zoom-reset-light.svg": 48433,
	"./flat/zoom-reset-solid.svg": 32067,
	"./fullColour/android.svg": 27825,
	"./fullColour/appLogo.svg": 19977,
	"./fullColour/app_store.svg": 70423,
	"./fullColour/apple.svg": 1958,
	"./fullColour/apps.svg": 40331,
	"./fullColour/base.svg": 34744,
	"./fullColour/box.svg": 16852,
	"./fullColour/calendar.svg": 80864,
	"./fullColour/card.svg": 67652,
	"./fullColour/chrome.svg": 30196,
	"./fullColour/context-cards.svg": 61531,
	"./fullColour/custom_external.svg": 89123,
	"./fullColour/custom_internal.svg": 63184,
	"./fullColour/do-not-disturb-dash-white.svg": 94555,
	"./fullColour/dropbox.svg": 27589,
	"./fullColour/firefox.svg": 97802,
	"./fullColour/form.svg": 19543,
	"./fullColour/gantt.svg": 64797,
	"./fullColour/gcalendar.svg": 71311,
	"./fullColour/gmail.svg": 72046,
	"./fullColour/google.svg": 57232,
	"./fullColour/google_play.svg": 47190,
	"./fullColour/googledrive.svg": 64281,
	"./fullColour/grid.svg": 70620,
	"./fullColour/hellosign.svg": 53702,
	"./fullColour/import-app.svg": 59073,
	"./fullColour/ios.svg": 38786,
	"./fullColour/jira.svg": 44791,
	"./fullColour/kanban.svg": 37103,
	"./fullColour/microsoft.svg": 75346,
	"./fullColour/mscalendar.svg": 59516,
	"./fullColour/msoutlook.svg": 58704,
	"./fullColour/msteams.svg": 29508,
	"./fullColour/onedrive.svg": 22428,
	"./fullColour/onedrivegcc.svg": 67818,
	"./fullColour/publisher.svg": 1873,
	"./fullColour/rules.svg": 1632,
	"./fullColour/safari.svg": 60138,
	"./fullColour/salesforce.svg": 79014,
	"./fullColour/shareddashboards.svg": 34956,
	"./fullColour/sharedtrackcontent.svg": 63928,
	"./fullColour/sharepoint.svg": 41086,
	"./fullColour/slack.svg": 19433,
	"./fullColour/smartsheet.svg": 14460,
	"./fullColour/table.svg": 64913,
	"./fullColour/templates.svg": 337,
	"./fullColour/whiteboardfox.svg": 31178,
	"./fullColour/workflows.svg": 98789,
	"./fullColour/zendesk.svg": 49317,
	"./fullColour/zoom.svg": 63392,
	"./light/application-light-focus.svg": 39501,
	"./light/application-light.svg": 20558,
	"./light/apps-light-focus.svg": 73192,
	"./light/apps-light.svg": 17148,
	"./light/attach-light-focus.svg": 44603,
	"./light/attach-light.svg": 60189,
	"./light/back-arrow-light-focus.svg": 29510,
	"./light/back-arrow-light.svg": 86269,
	"./light/book-light-focus.svg": 77813,
	"./light/book-light.svg": 24910,
	"./light/burger-menu-light-focus.svg": 58585,
	"./light/burger-menu-light.svg": 425,
	"./light/calendar-light-focus.svg": 31053,
	"./light/calendar-light.svg": 76316,
	"./light/camera-switch-light-focus.svg": 35588,
	"./light/camera-switch-light.svg": 55670,
	"./light/chat-light-focus.svg": 42235,
	"./light/chat-light.svg": 35757,
	"./light/delete-light-focus.svg": 56845,
	"./light/delete-light.svg": 49527,
	"./light/download-light-focus.svg": 57886,
	"./light/download-light.svg": 99593,
	"./light/edit-light-focus.svg": 15272,
	"./light/edit-light.svg": 68611,
	"./light/email-light-focus.svg": 70769,
	"./light/email-light.svg": 83592,
	"./light/emoji-light-focus.svg": 81763,
	"./light/emoji-light.svg": 60769,
	"./light/extensions-light-focus.svg": 42419,
	"./light/extensions-light.svg": 93365,
	"./light/eye-light-focus.svg": 77699,
	"./light/eye-light.svg": 64537,
	"./light/file-light-focus.svg": 6965,
	"./light/file-light.svg": 72155,
	"./light/files-light-focus.svg": 80787,
	"./light/files-light.svg": 60405,
	"./light/folder-closed-light-focus.svg": 4977,
	"./light/folder-closed-light.svg": 40830,
	"./light/folder-closed-move-up-light-focus.svg": 69723,
	"./light/folder-closed-move-up-light.svg": 39059,
	"./light/folder-open-light-focus.svg": 62087,
	"./light/folder-open-light.svg": 70469,
	"./light/help-light-focus.svg": 8920,
	"./light/help-light.svg": 26048,
	"./light/history-light-focus.svg": 35155,
	"./light/history-light.svg": 50512,
	"./light/home-light-focus.svg": 16984,
	"./light/home-light.svg": 79118,
	"./light/horizontal-ellipsis-light-focus.svg": 18781,
	"./light/horizontal-ellipsis-light.svg": 99,
	"./light/image-light-focus.svg": 94955,
	"./light/image-light.svg": 42134,
	"./light/info-light-focus.svg": 45315,
	"./light/info-light.svg": 43086,
	"./light/link-light-focus.svg": 33923,
	"./light/link-light.svg": 42848,
	"./light/log-out-light-focus.svg": 15187,
	"./light/log-out-light.svg": 86378,
	"./light/look-and-feel-light-focus.svg": 15993,
	"./light/look-and-feel-light.svg": 35464,
	"./light/maximise-light-focus.svg": 3420,
	"./light/maximise-light.svg": 89031,
	"./light/meeting-participant-add-light-focus.svg": 57992,
	"./light/meeting-participant-add-light.svg": 32581,
	"./light/members-add-light-focus.svg": 51196,
	"./light/members-add-light.svg": 99532,
	"./light/members-light-focus.svg": 54374,
	"./light/members-light.svg": 27414,
	"./light/minimise-light-focus.svg": 42380,
	"./light/minimise-light.svg": 22823,
	"./light/news-light-focus.svg": 23836,
	"./light/news-light.svg": 36655,
	"./light/notifications-light-focus.svg": 47319,
	"./light/notifications-light.svg": 16614,
	"./light/open-light-focus.svg": 15889,
	"./light/open-light.svg": 34716,
	"./light/organiser-light-focus.svg": 93156,
	"./light/organiser-light.svg": 61753,
	"./light/other-captcha-light-focus.svg": 92967,
	"./light/other-captcha-light.svg": 95726,
	"./light/other-stats-light-focus.svg": 41172,
	"./light/other-stats-light.svg": 73574,
	"./light/phone-down-light-focus.svg": 85098,
	"./light/phone-down-light.svg": 90929,
	"./light/phone-light-focus.svg": 72889,
	"./light/phone-light.svg": 60021,
	"./light/phone-up-light-focus.svg": 9323,
	"./light/phone-up-light.svg": 87686,
	"./light/pin-light-focus.svg": 57965,
	"./light/pin-light.svg": 11120,
	"./light/privacy-light-focus.svg": 88846,
	"./light/privacy-light.svg": 8508,
	"./light/private-light-focus.svg": 97380,
	"./light/private-light.svg": 13746,
	"./light/profile-light-focus.svg": 31393,
	"./light/profile-light.svg": 28326,
	"./light/reset-light.svg": 95957,
	"./light/search-light-focus.svg": 33147,
	"./light/search-light.svg": 46406,
	"./light/send-light-focus.svg": 5588,
	"./light/send-light.svg": 5294,
	"./light/settings-light-focus.svg": 6172,
	"./light/settings-light.svg": 94800,
	"./light/share-light-focus.svg": 41038,
	"./light/share-light.svg": 2134,
	"./light/share-social-light-focus.svg": 94762,
	"./light/share-social-light.svg": 53272,
	"./light/social-likes-light-focus.svg": 52937,
	"./light/social-likes-light.svg": 88984,
	"./light/tasks-light-focus.svg": 10541,
	"./light/tasks-light.svg": 91074,
	"./light/templates-light-focus.svg": 40841,
	"./light/templates-light.svg": 94450,
	"./light/thumb-up-light-focus.svg": 18651,
	"./light/thumb-up-light.svg": 66033,
	"./light/trash-3-light.svg": 39030,
	"./light/unknown-warning-light-focus.svg": 62850,
	"./light/unknown-warning-light.svg": 24568,
	"./light/users-authentication-light-focus.svg": 5961,
	"./light/users-authentication-light.svg": 41122,
	"./light/users-default-light-focus.svg": 15636,
	"./light/users-default-light.svg": 83224,
	"./light/video-light-focus.svg": 86075,
	"./light/video-light.svg": 31670,
	"./light/visibility-hidden.svg": 60302,
	"./light/visibility-invisible.svg": 64970,
	"./light/visibility-visible.svg": 21661,
	"./light/workflows-light-focus.svg": 39849,
	"./light/workflows-light.svg": 13,
	"./light/workspaces-light-focus.svg": 9614,
	"./light/workspaces-light.svg": 14667,
	"./light/x-light-focus.svg": 41858,
	"./light/x-light.svg": 40099,
	"./meetings/camera-compact-focus.svg": 75437,
	"./meetings/camera-compact.svg": 94896,
	"./meetings/camera-light-focus.svg": 97062,
	"./meetings/camera-light.svg": 49523,
	"./meetings/camera-muted-compact-focus.svg": 44581,
	"./meetings/camera-muted-compact.svg": 39948,
	"./meetings/camera-muted-light-focus.svg": 37005,
	"./meetings/camera-muted-light.svg": 70113,
	"./meetings/full-screen-compact-focus.svg": 64071,
	"./meetings/full-screen-compact.svg": 54618,
	"./meetings/full-screen-exit-compact-focus.svg": 41418,
	"./meetings/full-screen-exit-compact.svg": 74706,
	"./meetings/full-screen-exit-light-focus.svg": 82888,
	"./meetings/full-screen-exit-light.svg": 94890,
	"./meetings/full-screen-light-focus.svg": 75640,
	"./meetings/full-screen-light.svg": 34136,
	"./meetings/layout-film-strip-compact-focus.svg": 29871,
	"./meetings/layout-film-strip-compact.svg": 1685,
	"./meetings/layout-film-strip-light-focus.svg": 64025,
	"./meetings/layout-film-strip-light.svg": 84182,
	"./meetings/layout-full-screen-compact-focus.svg": 1037,
	"./meetings/layout-full-screen-compact.svg": 39377,
	"./meetings/layout-full-screen-light-focus.svg": 23230,
	"./meetings/layout-full-screen-light.svg": 75916,
	"./meetings/layout-grid-compact-focus.svg": 64138,
	"./meetings/layout-grid-compact.svg": 22314,
	"./meetings/layout-grid-light-focus.svg": 55447,
	"./meetings/layout-grid-light.svg": 66382,
	"./meetings/layout-righthand-strip-compact-focus.svg": 16777,
	"./meetings/layout-righthand-strip-compact.svg": 71326,
	"./meetings/layout-righthand-strip-light-focus.svg": 77973,
	"./meetings/layout-righthand-strip-light.svg": 96920,
	"./meetings/microphone-compact-focus.svg": 48975,
	"./meetings/microphone-compact.svg": 96889,
	"./meetings/microphone-light-focus.svg": 18530,
	"./meetings/microphone-light.svg": 18810,
	"./meetings/microphone-muted-compact-focus.svg": 59418,
	"./meetings/microphone-muted-compact.svg": 22194,
	"./meetings/microphone-muted-light-focus.svg": 27562,
	"./meetings/microphone-muted-light.svg": 27530,
	"./meetings/present-compact-focus.svg": 63208,
	"./meetings/present-compact.svg": 22736,
	"./meetings/present-light-focus.svg": 57768,
	"./meetings/present-light.svg": 33579,
	"./meetings/record-compact-focus.svg": 837,
	"./meetings/record-compact.svg": 55303,
	"./meetings/record-light-focus.svg": 93308,
	"./meetings/record-light.svg": 79385,
	"./meetings/recording-compact-focus.svg": 96138,
	"./meetings/recording-compact.svg": 87841,
	"./meetings/recording-light-focus.svg": 17932,
	"./meetings/recording-light.svg": 80520,
	"./meetings/screenshare-compact-focus.svg": 10162,
	"./meetings/screenshare-compact.svg": 11130,
	"./meetings/screenshare-light-focus.svg": 87526,
	"./meetings/screenshare-light.svg": 36396,
	"./solid/application-solid-focus.svg": 90281,
	"./solid/application-solid.svg": 76144,
	"./solid/approval-solid-focus.svg": 51150,
	"./solid/approval-solid.svg": 29601,
	"./solid/apps-solid-focus.svg": 25837,
	"./solid/apps-solid.svg": 9041,
	"./solid/attach-solid-focus.svg": 59088,
	"./solid/attach-solid.svg": 8760,
	"./solid/base-solid-focus.svg": 74059,
	"./solid/base-solid.svg": 40572,
	"./solid/book-solid-focus.svg": 16967,
	"./solid/book-solid.svg": 58398,
	"./solid/bottom-focus.svg": 94354,
	"./solid/bottom.svg": 27946,
	"./solid/burger-menu-solid-focus.svg": 54634,
	"./solid/burger-menu-solid.svg": 20972,
	"./solid/calendar-solid-focus.svg": 60385,
	"./solid/calendar-solid.svg": 39309,
	"./solid/camera-switch-solid-focus.svg": 12208,
	"./solid/camera-switch-solid.svg": 36670,
	"./solid/card-solid-focus.svg": 60520,
	"./solid/card-solid.svg": 333,
	"./solid/chat-solid-focus.svg": 61121,
	"./solid/chat-solid.svg": 8126,
	"./solid/close-solid-focus.svg": 87534,
	"./solid/close-solid.svg": 10178,
	"./solid/comment-solid-focus.svg": 91317,
	"./solid/comment-solid.svg": 88620,
	"./solid/copy-solid-focus.svg": 72892,
	"./solid/copy-solid.svg": 99194,
	"./solid/delete-solid-focus.svg": 73154,
	"./solid/delete-solid.svg": 75312,
	"./solid/down-focus.svg": 30944,
	"./solid/down.svg": 28462,
	"./solid/download-solid-focus.svg": 15341,
	"./solid/download-solid.svg": 74052,
	"./solid/edit-solid-focus.svg": 23448,
	"./solid/edit-solid.svg": 793,
	"./solid/email-solid-focus.svg": 68604,
	"./solid/email-solid.svg": 94860,
	"./solid/emoji-solid-focus.svg": 44676,
	"./solid/emoji-solid.svg": 34489,
	"./solid/extensions-solid-focus.svg": 10724,
	"./solid/extensions-solid.svg": 26677,
	"./solid/eye-solid-focus.svg": 28831,
	"./solid/eye-solid.svg": 40039,
	"./solid/file-solid-focus.svg": 23003,
	"./solid/file-solid.svg": 2426,
	"./solid/files-solid-focus.svg": 73767,
	"./solid/files-solid.svg": 92041,
	"./solid/first-focus.svg": 90637,
	"./solid/first.svg": 30019,
	"./solid/folder-closed-move-up-solid-focus.svg": 75059,
	"./solid/folder-closed-move-up-solid.svg": 53104,
	"./solid/folder-closed-solid-focus.svg": 5895,
	"./solid/folder-closed-solid.svg": 78341,
	"./solid/folder-open-solid-focus.svg": 73237,
	"./solid/folder-open-solid.svg": 92563,
	"./solid/form-solid-focus.svg": 65699,
	"./solid/form-solid.svg": 28345,
	"./solid/gantt-solid-focus.svg": 71319,
	"./solid/gantt-solid.svg": 86528,
	"./solid/grid-solid-focus.svg": 76517,
	"./solid/grid-solid.svg": 5697,
	"./solid/group-solid-focus.svg": 18360,
	"./solid/group-solid.svg": 75010,
	"./solid/history-solid-focus.svg": 92696,
	"./solid/history-solid.svg": 88853,
	"./solid/home-solid-focus.svg": 83085,
	"./solid/home-solid.svg": 58260,
	"./solid/info-solid-focus.svg": 57762,
	"./solid/info-solid.svg": 67682,
	"./solid/kanban-solid-focus.svg": 41562,
	"./solid/kanban-solid.svg": 35997,
	"./solid/last-focus.svg": 12233,
	"./solid/last.svg": 24157,
	"./solid/left-focus.svg": 1651,
	"./solid/left.svg": 87510,
	"./solid/link-solid-focus.svg": 69570,
	"./solid/link-solid.svg": 52529,
	"./solid/list-solid-focus.svg": 61785,
	"./solid/list-solid.svg": 25433,
	"./solid/lock-solid-focus.svg": 47598,
	"./solid/lock-solid.svg": 13103,
	"./solid/log-out-solid-focus.svg": 68985,
	"./solid/log-out-solid.svg": 53260,
	"./solid/look-and-feel-solid-focus.svg": 59359,
	"./solid/look-and-feel-solid.svg": 14159,
	"./solid/maximise-solid-focus.svg": 91253,
	"./solid/maximise-solid.svg": 85636,
	"./solid/meeting-participant-add-solid-focus.svg": 73903,
	"./solid/meeting-participant-add-solid.svg": 33020,
	"./solid/members-add-solid-focus.svg": 87798,
	"./solid/members-add-solid.svg": 38561,
	"./solid/members-solid-focus.svg": 69035,
	"./solid/members-solid.svg": 71221,
	"./solid/microphone-solid-focus.svg": 27622,
	"./solid/microphone-solid.svg": 3244,
	"./solid/minimise-solid-focus.svg": 88574,
	"./solid/minimise-solid.svg": 87766,
	"./solid/news-solid-focus.svg": 27013,
	"./solid/news-solid.svg": 61045,
	"./solid/note-solid-focus.svg": 99225,
	"./solid/note-solid.svg": 44279,
	"./solid/notifications-solid-focus.svg": 4781,
	"./solid/notifications-solid.svg": 42783,
	"./solid/open-solid-focus.svg": 24450,
	"./solid/open-solid.svg": 90037,
	"./solid/organiser-solid-focus.svg": 51858,
	"./solid/organiser-solid.svg": 75989,
	"./solid/other-captcha-solid-focus.svg": 96509,
	"./solid/other-captcha-solid.svg": 29861,
	"./solid/phone-down-solid-focus.svg": 93281,
	"./solid/phone-down-solid.svg": 27915,
	"./solid/phone-solid-focus.svg": 84914,
	"./solid/phone-solid.svg": 44734,
	"./solid/phone-up-solid-focus.svg": 95436,
	"./solid/phone-up-solid.svg": 40844,
	"./solid/pin-solid-focus.svg": 73701,
	"./solid/pin-solid.svg": 62999,
	"./solid/play-solid-focus.svg": 78758,
	"./solid/play-solid.svg": 61025,
	"./solid/plus-solid-focus.svg": 25310,
	"./solid/plus-solid.svg": 69705,
	"./solid/privacy-solid-focus.svg": 88455,
	"./solid/privacy-solid.svg": 31645,
	"./solid/profile-solid-focus.svg": 12066,
	"./solid/profile-solid.svg": 84237,
	"./solid/reaction-add-solid-focus.svg": 69058,
	"./solid/reaction-add-solid.svg": 98237,
	"./solid/reset-solid.svg": 3579,
	"./solid/right-focus.svg": 16543,
	"./solid/right.svg": 18246,
	"./solid/search-solid-focus.svg": 44169,
	"./solid/search-solid.svg": 73398,
	"./solid/send-solid-focus.svg": 32711,
	"./solid/send-solid.svg": 44564,
	"./solid/settings-solid-focus.svg": 88203,
	"./solid/settings-solid.svg": 23347,
	"./solid/share-solid-focus.svg": 38583,
	"./solid/share-solid.svg": 85752,
	"./solid/sliders-solid-focus.svg": 44639,
	"./solid/sliders-solid.svg": 16027,
	"./solid/social-likes-solid-focus.svg": 5283,
	"./solid/social-likes-solid.svg": 15165,
	"./solid/start-thread-solid-focus.svg": 80136,
	"./solid/start-thread-solid.svg": 36938,
	"./solid/stats-solid-focus.svg": 23868,
	"./solid/stats-solid.svg": 54300,
	"./solid/table-solid-focus.svg": 3224,
	"./solid/table-solid.svg": 74445,
	"./solid/tasks-solid-focus.svg": 58196,
	"./solid/tasks-solid.svg": 99170,
	"./solid/templates-solid-focus.svg": 8461,
	"./solid/templates-solid.svg": 59225,
	"./solid/text-file-solid-focus.svg": 21216,
	"./solid/text-file-solid.svg": 76916,
	"./solid/tile-view-solid-focus.svg": 95798,
	"./solid/tile-view-solid.svg": 63576,
	"./solid/top-focus.svg": 94503,
	"./solid/top.svg": 38568,
	"./solid/trash-3-solid.svg": 96973,
	"./solid/trash-solid-focus.svg": 41563,
	"./solid/trash-solid.svg": 17801,
	"./solid/unknown-warning-solid-focus.svg": 45977,
	"./solid/unknown-warning-solid.svg": 45932,
	"./solid/up-focus.svg": 66582,
	"./solid/up.svg": 33588,
	"./solid/users-authentication-solid-focus.svg": 30294,
	"./solid/users-authentication-solid.svg": 92270,
	"./solid/video-solid-focus.svg": 59777,
	"./solid/video-solid.svg": 54673,
	"./solid/visibility-hidden.svg": 90665,
	"./solid/visibility-invisible.svg": 67463,
	"./solid/visibility-visible.svg": 30776,
	"./solid/warning-solid.svg": 85358,
	"./solid/workflows-solid-focus.svg": 15499,
	"./solid/workflows-solid.svg": 30331,
	"./solid/workspaces-solid-focus.svg": 71578,
	"./solid/workspaces-solid.svg": 59100,
	"./solid/x-solid-focus.svg": 80514,
	"./solid/x-solid.svg": 14215,
	"./special/add-focus.svg": 74692,
	"./special/add.svg": 39018,
	"./special/chevron-down-focus.svg": 78212,
	"./special/chevron-down.svg": 14098,
	"./special/chevron-left-focus.svg": 8781,
	"./special/chevron-left.svg": 59934,
	"./special/chevron-right-focus.svg": 22786,
	"./special/chevron-right.svg": 82316,
	"./special/chevron-up-focus.svg": 39088,
	"./special/chevron-up.svg": 22437,
	"./special/dash-focus.svg": 72626,
	"./special/dash.svg": 52026,
	"./special/dismiss-focus.svg": 77732,
	"./special/dismiss.svg": 2538,
	"./special/do-not-disturb-focus.svg": 45270,
	"./special/do-not-disturb.svg": 2803,
	"./special/down-focus.svg": 28435,
	"./special/down.svg": 11395,
	"./special/draggable-handle-focus.svg": 90872,
	"./special/draggable-handle.svg": 66968,
	"./special/ellipsis-focus.svg": 94013,
	"./special/ellipsis.svg": 81540,
	"./special/favourite-checked-focus.svg": 12773,
	"./special/favourite-checked.svg": 32500,
	"./special/favourite-focus.svg": 29172,
	"./special/favourite.svg": 1738,
	"./special/left-focus.svg": 51126,
	"./special/left.svg": 15374,
	"./special/nudge-down-focus.svg": 30780,
	"./special/nudge-down.svg": 72940,
	"./special/nudge-right-focus.svg": 72809,
	"./special/nudge-right.svg": 93710,
	"./special/pin-solid-focus.svg": 53323,
	"./special/pin-solid.svg": 24750,
	"./special/pop-out-to-modal-focus.svg": 3094,
	"./special/pop-out-to-modal.svg": 72973,
	"./special/right-focus.svg": 89121,
	"./special/right.svg": 95950,
	"./special/tick-focus.svg": 89814,
	"./special/tick.svg": 49779,
	"./special/up-focus.svg": 2138,
	"./special/up.svg": 14978,
	"./text-formatting/block-quote-focus.svg": 14797,
	"./text-formatting/block-quote.svg": 5296,
	"./text-formatting/bold-focus.svg": 58058,
	"./text-formatting/bold.svg": 7185,
	"./text-formatting/code-block-focus.svg": 27203,
	"./text-formatting/code-block.svg": 22966,
	"./text-formatting/code-focus.svg": 46747,
	"./text-formatting/code.svg": 35566,
	"./text-formatting/fill-colour-focus.svg": 97354,
	"./text-formatting/fill-colour.svg": 27641,
	"./text-formatting/image-focus.svg": 94218,
	"./text-formatting/image.svg": 37397,
	"./text-formatting/italic-focus.svg": 86983,
	"./text-formatting/italic.svg": 97007,
	"./text-formatting/link-focus.svg": 47154,
	"./text-formatting/link.svg": 48144,
	"./text-formatting/ordered-list-focus.svg": 83720,
	"./text-formatting/ordered-list.svg": 70179,
	"./text-formatting/strikethrough-focus.svg": 59665,
	"./text-formatting/strikethrough.svg": 31121,
	"./text-formatting/text-colour-focus.svg": 68295,
	"./text-formatting/text-colour.svg": 6569,
	"./text-formatting/text-formatting-focus.svg": 39971,
	"./text-formatting/text-formatting.svg": 50183,
	"./text-formatting/underline-focus.svg": 27658,
	"./text-formatting/underline.svg": 48621,
	"./text-formatting/unordered-list-focus.svg": 35179,
	"./text-formatting/unordered-list.svg": 56995,
	"./xwiki/compact/application-index-small-xwiki-compact-focus.svg": 88935,
	"./xwiki/compact/application-index-small-xwiki-compact.svg": 34499,
	"./xwiki/compact/class-small-xwiki-compact-focus.svg": 96996,
	"./xwiki/compact/class-small-xwiki-compact.svg": 5892,
	"./xwiki/compact/export-small-xwiki-compact-focus.svg": 48941,
	"./xwiki/compact/export-small-xwiki-compact.svg": 76152,
	"./xwiki/compact/heart-small-xwiki-compact-focus.svg": 67866,
	"./xwiki/compact/heart-small-xwiki-compact.svg": 23961,
	"./xwiki/compact/index-small-xwiki-compact-focus.svg": 68792,
	"./xwiki/compact/index-small-xwiki-compact.svg": 4865,
	"./xwiki/compact/log-out-person-small-xwiki-compact-focus.svg": 96410,
	"./xwiki/compact/log-out-person-small-xwiki-compact.svg": 48287,
	"./xwiki/compact/objects-small-xwiki-compact-focus.svg": 87823,
	"./xwiki/compact/objects-small-xwiki-compact.svg": 58117,
	"./xwiki/compact/print-small-xwiki-compact-focus.svg": 7779,
	"./xwiki/compact/print-small-xwiki-compact.svg": 15738,
	"./xwiki/compact/upload-small-xwiki-compact-focus.svg": 21320,
	"./xwiki/compact/upload-small-xwiki-compact.svg": 55892,
	"./xwiki/compact/wiki-small-xwiki-compact-focus.svg": 49520,
	"./xwiki/compact/wiki-small-xwiki-compact.svg": 28835,
	"./xwiki/light/applications-xwiki-light-focus.svg": 15803,
	"./xwiki/light/applications-xwiki-light.svg": 68315,
	"./xwiki/light/compass-xwiki-light-focus.svg": 12038,
	"./xwiki/light/compass-xwiki-light.svg": 56825,
	"./xwiki/light/content-annotation-xwiki-light-focus.svg": 96884,
	"./xwiki/light/content-annotation-xwiki-light.svg": 46114,
	"./xwiki/light/content-delete-xwiki-light-focus.svg": 80531,
	"./xwiki/light/content-delete-xwiki-light.svg": 82749,
	"./xwiki/light/content-export-xwiki-light-focus.svg": 24808,
	"./xwiki/light/content-export-xwiki-light.svg": 9936,
	"./xwiki/light/content-file-server-xwiki-light-focus.svg": 79935,
	"./xwiki/light/content-file-server-xwiki-light.svg": 63465,
	"./xwiki/light/content-import-xwiki-light-focus.svg": 23732,
	"./xwiki/light/content-import-xwiki-light.svg": 20704,
	"./xwiki/light/content-localisation-xwiki-light-focus.svg": 60081,
	"./xwiki/light/content-localisation-xwiki-light.svg": 7234,
	"./xwiki/light/content-templates-xwiki-light-focus.svg": 72739,
	"./xwiki/light/content-templates-xwiki-light.svg": 55671,
	"./xwiki/light/edit-mode-xwiki-light-focus.svg": 47493,
	"./xwiki/light/edit-mode-xwiki-light.svg": 49595,
	"./xwiki/light/edit-naming-xwiki-light-focus.svg": 27264,
	"./xwiki/light/edit-naming-xwiki-light.svg": 92700,
	"./xwiki/light/edit-syntax-highlighting-xwiki-light-focus.svg": 53839,
	"./xwiki/light/edit-syntax-highlighting-xwiki-light.svg": 13536,
	"./xwiki/light/edit-syntaxes-xwiki-light-focus.svg": 6574,
	"./xwiki/light/edit-syntaxes-xwiki-light.svg": 99387,
	"./xwiki/light/edit-wysiwyg-xwiki-light-focus.svg": 97491,
	"./xwiki/light/edit-wysiwyg-xwiki-light.svg": 69482,
	"./xwiki/light/email-advanced-settings-xwiki-light-focus.svg": 63750,
	"./xwiki/light/email-advanced-settings-xwiki-light.svg": 46818,
	"./xwiki/light/email-sending-status-xwiki-light-focus.svg": 92655,
	"./xwiki/light/email-sending-status-xwiki-light.svg": 54096,
	"./xwiki/light/email-sending-xwiki-light-focus.svg": 58346,
	"./xwiki/light/email-sending-xwiki-light.svg": 92524,
	"./xwiki/light/extensions-history-xwiki-light-focus.svg": 22297,
	"./xwiki/light/extensions-history-xwiki-light.svg": 93686,
	"./xwiki/light/extensions-update-xwiki-light-focus.svg": 84910,
	"./xwiki/light/extensions-update-xwiki-light.svg": 53679,
	"./xwiki/light/menus-xwiki-light-focus.svg": 99370,
	"./xwiki/light/menus-xwiki-light.svg": 1092,
	"./xwiki/light/other-logging-xwiki-light-focus.svg": 40544,
	"./xwiki/light/other-logging-xwiki-light.svg": 63470,
	"./xwiki/light/panels-xwiki-light-focus.svg": 76232,
	"./xwiki/light/panels-xwiki-light.svg": 73700,
	"./xwiki/light/presentation-xwiki-light-focus.svg": 86943,
	"./xwiki/light/presentation-xwiki-light.svg": 99150,
	"./xwiki/light/search-suggest-xwiki-light-focus.svg": 54244,
	"./xwiki/light/search-suggest-xwiki-light.svg": 82952,
	"./xwiki/light/social-mentions-xwiki-light-focus.svg": 85421,
	"./xwiki/light/social-mentions-xwiki-light.svg": 59936,
	"./xwiki/light/social-message-stream-xwiki-light-focus.svg": 43160,
	"./xwiki/light/social-message-stream-xwiki-light.svg": 55524,
	"./xwiki/light/social-notifications-xwiki-light-focus.svg": 86934,
	"./xwiki/light/social-notifications-xwiki-light.svg": 6020,
	"./xwiki/light/thread-xwiki-light-focus.svg": 76520,
	"./xwiki/light/thread-xwiki-light.svg": 98174,
	"./xwiki/light/users-directory-xwiki-light-focus.svg": 16769,
	"./xwiki/light/users-directory-xwiki-light.svg": 5317,
	"./xwiki/light/users-groups-xwiki-light-focus.svg": 73853,
	"./xwiki/light/users-groups-xwiki-light.svg": 67254,
	"./xwiki/light/users-invitation-xwiki-light-focus.svg": 50979,
	"./xwiki/light/users-invitation-xwiki-light.svg": 72121,
	"./xwiki/light/users-profile-xwiki-light-focus.svg": 29276,
	"./xwiki/light/users-profile-xwiki-light.svg": 67497,
	"./xwiki/light/users-registration-xwiki-light-focus.svg": 3769,
	"./xwiki/light/users-registration-xwiki-light.svg": 27452,
	"./xwiki/light/users-rights-xwiki-light-focus.svg": 89805,
	"./xwiki/light/users-rights-xwiki-light.svg": 60709,
	"./xwiki/light/wiki-descriptor-xwiki-light-focus.svg": 7226,
	"./xwiki/light/wiki-descriptor-xwiki-light.svg": 38017,
	"./xwiki/light/wiki-rights-xwiki-light-focus.svg": 47547,
	"./xwiki/light/wiki-rights-xwiki-light.svg": 76643,
	"./xwiki/light/wiki-templates-xwiki-light-focus.svg": 31328,
	"./xwiki/light/wiki-templates-xwiki-light.svg": 50269,
	"./xwiki/light/wiki-xwiki-light-focus.svg": 31935,
	"./xwiki/light/wiki-xwiki-light.svg": 64126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83844;